/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit DefaultPayorSchedule/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import InstallmentAmount from './InstallmentAmount/index'
import PaymentPlanLength from './PaymentPlanLength/index'
import React from 'react'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function DefaultPayorSchedule({
  children,
  viewPath = "/App/Account/Content/Settings/Content/TreatmentPayments/Content/Content/DefaultPayorSchedule"
  
}) {
let dtSpaceS = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.s'
        })
  return (<React.Fragment
>
<div
  data-testid="DefaultPayorSchedule.Vertical"
  data-view-path={viewPath}
 style={{'--g-1-Z2poBEf': typeof dtSpaceS === 'number' ? `${dtSpaceS}px` : dtSpaceS}}
 className={`views-block ${styles.Vertical}`}
>
<TysiaInputLabel
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Select which default you would prefer"
/>
<InstallmentAmount
  viewPath={`${viewPath}/InstallmentAmount`}
/>
<PaymentPlanLength
  viewPath={`${viewPath}/PaymentPlanLength`}
/>
</div>
{children}
</React.Fragment>)
}